module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "lgc"
  }, [_c('h1', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "gesp"
  }, [_vm._v("L I N N E T")])]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }, [_c('span', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "gesp"
  }, [_vm._v("A  R O M A N C E")])])])]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "line2"
  }, [_c('span', {
    staticClass: "gesp"
  }, [_c('span', {
    staticClass: "it"
  }, [_vm._v("By")])]), _vm._v(" "), _c('span', {
    staticClass: "gesp"
  }, [_vm._v("GRANT ALLEN")])]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "line3"
  }, [_c('span', {
    staticClass: "it1"
  }, [_vm._v("Author of")]), _vm._v(" “UNDER SEALED ORDERS,”")]), _vm._v(" "), _c('p', {
    staticClass: "line3"
  }, [_vm._v("“MISS CAYLEY’S ADVENTURES,” ETC.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("NOTE")]), _c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "literal-container"
  }, [_c('div', {
    staticClass: "literal"
  }, [_c('p', {
    staticClass: "line4"
  }, [_vm._v("This story was written in the midst of the scenery which")]), _vm._v(" "), _c('p', {
    staticClass: "line4"
  }, [_vm._v("it describes; but the author desires to acknowledge his")]), _vm._v(" "), _c('p', {
    staticClass: "line4"
  }, [_vm._v("obligations for many touches of local colour to Mr.")]), _vm._v(" "), _c('p', {
    staticClass: "line4"
  }, [_vm._v("Baillie-Grohman’s admirable work on “Tyrol and the")]), _vm._v(" "), _c('p', {
    staticClass: "line4"
  }, [_vm._v("Tyrolese.” The quatrain on p. 283 is quoted, with")]), _vm._v(" "), _c('p', {
    staticClass: "line4"
  }, [_vm._v("some slight modifications (to adapt it to its place")]), _vm._v(" "), _c('p', {
    staticClass: "line4"
  }, [_vm._v("in this novel), from a poem by Mr. William Watson.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5cd8782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 57
// module chunks = 0